export default __webpack_public_path__ + "static/media/js_ico.5e30111d.svg";